import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
dayjs.extend(relativeTime)

function fromNow(date) {
  return dayjs(date).fromNow(true)
}


function date(date) {
  const format = "YYYY-MM-DD HH:mm:ss"
  return dayjs(date).format(format)
}

export {
  fromNow,
  date
}